import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import Loading from './Loading';
import { Link, useHistory } from 'react-router-dom';
import CardPlay from '../Item/CardPlay';
import { useDataLayerValue } from '../../DataLayer';
import { CONVERT_TO_SLUG } from '../../constants/format';


function Search(props) {
    const [{ lang, search }] = useDataLayerValue();
    const [loadingPage, setLoadingPage] = useState(true);
    const [listSong, setListSong] = useState([]);
    let history = useHistory();

    useEffect(() => {
        if (!loadingPage || search.trim() !== '') {
            setLoadingPage(true);
            const slug = CONVERT_TO_SLUG(search);
            db.collection("songs").where("status", "==", true).where("find_row", ">=", `${slug}`).limit(10)
                .get()
                .then(function (querySnapshot) {
                    setListSong(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
                    setLoadingPage(false);
                })
                .catch(function (error) {
                    console.log("Error get result by search");
                    history.push('/error');
                });
        }
        if (search.trim() === '' || listSong.length > 0) {
            setLoadingPage(false);
        }


    }, [search]);



    return (
        <div className="Root__right-container__scroll">
            <div className="Root__right-container__section--wrap">
                <section className="Root__right-container__section">
                    <div className="container__section--title__warp">
                        <div className="container__section--title__warp--left">
                            <h2 className="container__section--title__top">
                                <Link to="/search" draggable="false" className="container__section--title__top-a" >{lang == 'en' ? 'Search' : 'Tìm kiếm'}  </Link>
                            </h2>
                        </div>
                    </div>
                    <div className={` container__section--list-card  ${window.innerWidth <= 600 ? 'list-card-vertical-mobile' : ''}`}>
                        {
                            listSong.map((item, index) => (
                                <Link to={`/song/${item.id}`} key={index}>
                                    <CardPlay key={index} idPlaylist={item.id ? item.id : ''} title={lang == 'en' ? item.name_en : item.name_vi} subtitle={lang == 'en' ? item.subtitle_en : item.subtitle_vi} image={item.avatar ? item.avatar : ''} />
                                </Link>
                            ))
                        }
                    </div>
                </section>
            </div>
            <Loading loadingPage={loadingPage} />
        </div >
    );

}

export default Search;